import { Component } from '@angular/core';

@Component({
  selector: 'liberro-highlighted-content',
  standalone: false,
  templateUrl: './liberro-highlighted-content.component.html',
  styleUrl: './liberro-highlighted-content.component.less'
})
export class LiberroHighlightedContentComponent {

}
